exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-form-wrapper[data-v-d3fff896] {\n  padding: 1.5rem 2rem;\n  border-top: 0.1rem solid #CFCFCF;\n}\n.comment-form[data-v-d3fff896] {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  padding-right: 1.7rem;\n}\n.comment-form .avatar[data-v-d3fff896] {\n  height: 3.6rem;\n  width: 3.6rem;\n}\n.comment-form .btn[data-v-d3fff896] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}", ""]);

// exports
